// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getReports } from '../../../api/remote-api/.portal.generated/fn/reports/get-reports';
import {
  GetReportsAccessLink$Params,
  getReportsAccessLink,
} from '../../../api/remote-api/.portal.generated/fn/reports/get-reports-access-link';
import { DocBoxDocumentAccessModel } from '../../../api/remote-api/.portal.generated/models';
import {
  MapApiService,
  keyBySerialAndMaterialNumber,
} from '../../shared/services/map-api.service';
import { APICallState } from '../../shared/utils/api-call-state.util';
export {
  DocBoxDocument,
  DocBoxDocumentAccessModel,
  DocBoxDocumentModel,
} from '../../../api/remote-api/.portal.generated/models';

/**
 * fetches doc box results for system.
 * catches exactly one result!
 */
export interface HttpRequestState<T> {
  loading: boolean;
  result?: T;
  error?: HttpErrorResponse | Error;
}

@Injectable({
  providedIn: 'root',
})
export class DocBoxService {
  docBoxEntries = this.mapApiService.mapEndpoint(getReports, {
    customCacheKey: keyBySerialAndMaterialNumber, // be lazy in case requesting same system
  });

  public requestLifecycle(
    ids: string[]
  ): APICallState<
    GetReportsAccessLink$Params,
    DocBoxDocumentAccessModel,
    GetReportsAccessLink$Params
  > {
    const requestLifecycle =
      this.mapApiService.mapEndpoint(getReportsAccessLink);
    requestLifecycle.request({ body: ids });
    return requestLifecycle;
  }

  constructor(private mapApiService: MapApiService) {}
}
